<!-- src/components/AlertModal.vue -->
<template>
  <b-modal
    v-model="visible"
    hide-header-close
    noFooter
    :title="title"
    size="md"
    centered
    scrollable
  >
    <!-- aqui: renderiza HTML em vez de texto puro -->
    <div v-safe-html="message"></div>

    <div class="text-end mt-3">
      <!-- Se for apenas alerta, um botão "OK" basta -->
      <b-button
        v-if="type === 'alert'"
        variant="primary"
        class="btn-modal"
        @click="onClose"
      >
        OK
      </b-button>

      <!-- Se for confirm, dois botões "Cancelar" e "OK" -->
      <template v-else>
        <b-button
          variant="secondary"
          class="btn-modal"
          @click="onCancel"
        >
          Cancelar
        </b-button>
        <b-button
          variant="primary"
          class="btn-modal ms-2"
          @click="onConfirm"
        >
          OK
        </b-button>
      </template>
    </div>
  </b-modal>
</template>

<script setup>
import { ref, watch } from 'vue'
import { safeHtmlDirective as vSafeHtml } from '@/utils/safeHtml'
import { BModal, BButton } from 'bootstrap-vue-next'

const props = defineProps({
  visible:  { type: Boolean, default: false },
  message:  { type: String,  default: '' },
  title:    { type: String,  default: 'Aviso' },
  type:     { type: String,  default: 'alert' } // 'alert' ou 'confirm'
})
const emits = defineEmits(['close','confirm','cancel'])

const visible = ref(props.visible)
// se o pai controlar via prop, sincroniza
watch(() => props.visible, v => visible.value = v)

function onClose() {
  emits('close'); visible.value = false
}
function onConfirm() {
  emits('confirm'); visible.value = false
}
function onCancel() {
  emits('cancel');  visible.value = false
}
</script>

<style scoped>
.btn-modal {
  min-width: 45px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: small;
}
</style>
